import { render, staticRenderFns } from "./BuyCredit.vue?vue&type=template&id=c416abbe"
import script from "./BuyCredit.vue?vue&type=script&lang=ts"
export * from "./BuyCredit.vue?vue&type=script&lang=ts"
import style0 from "./BuyCredit.vue?vue&type=style&index=0&id=c416abbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports